module.exports = __webpack_public_path__ + "a68574ff4bf72f1b4f9805f72c72e1e7.svg";